import { render, staticRenderFns } from "./defaultTable.vue?vue&type=template&id=2e7d5890&scoped=true&"
import script from "./defaultTable.vue?vue&type=script&lang=js&"
export * from "./defaultTable.vue?vue&type=script&lang=js&"
import style0 from "./defaultTable.vue?vue&type=style&index=0&id=2e7d5890&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d5890",
  null
  
)

export default component.exports